import { Check, X } from 'lucide-react'
import { cn } from '../../lib/utils'
import { PASSWORD_RULES } from '../../lib/password-rules'

interface PasswordRequirementsProps {
  /** Current password value; each rule re-evaluates live as this changes. */
  password: string
  className?: string
}

/**
 * Real-time password requirements checklist. Each rule shows a green check
 * when met and a muted cross when not, updating as the user types.
 */
export function PasswordRequirements({ password, className }: PasswordRequirementsProps) {
  // Unmet rules inherit the list's base colour (override via `className` on dark
  // surfaces, e.g. text-slate-400); met rules always turn green.
  return (
    <ul className={cn('space-y-1 text-sm text-muted-foreground', className)} aria-live="polite">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password)
        return (
          <li key={rule.id} className={cn('flex items-center gap-2', met && 'text-green-600 dark:text-green-500')}>
            {met ? (
              <Check className="h-4 w-4 shrink-0" aria-hidden="true" />
            ) : (
              <X className="h-4 w-4 shrink-0" aria-hidden="true" />
            )}
            <span>{rule.label}</span>
            <span className="sr-only">{met ? '— met' : '— not met'}</span>
          </li>
        )
      })}
    </ul>
  )
}
